import { Typography } from "@mui/material";
import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";

import { APIError } from "src/types";
import { parseServerError } from "src/utils/string.utils";

interface Props {
  importWarnings: APIError[];
}

export function ImportFinished(props: Props) {
  const { importWarnings } = props;
  const { t } = useTranslation();

  return render();

  function render() {
    return (
      <StyledAlert icon={false} variant="standard" severity="success">
        <Typography variant="h3" gutterBottom>
          {t("label.thePreviousImportWasSuccessful")}
        </Typography>

        {importWarnings.length > 0 && (
          <>
            <Typography variant="body1" gutterBottom>
              {t("label.takeNoteOfTheFollowingWarnings")}
            </Typography>

            <ul className="warning-list">
              {importWarnings.map((importWarning, i) => (
                <li key={i}>{parseServerError(importWarning)}</li>
              ))}
            </ul>
          </>
        )}
      </StyledAlert>
    );
  }
}

const StyledAlert = styled(Alert)`
  padding: ${({ theme }) => theme.spacing(2, 2)};

  .warning-list {
    padding: ${({ theme }) => theme.spacing(0, 0)};
    padding-inline-start: ${({ theme }) => theme.spacing(2)};
  }
`;
